import React from 'react';
import { ListingBadges } from '@domain-group/fe-allhomes-library';
import { variables } from '@domain-group/fe-brary';
import * as styles from './allhomes-listing-card-badges.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesListingCardBadges = props => {
  var colour = variables.colour;
  var getBadge = (badgeEnum, label) => {
    var bgColour;
    if (badgeEnum === ListingBadges.underApplication) {
      bgColour = colour.brandYellow;
    } else if (badgeEnum === ListingBadges.featuredProperty || badgeEnum === ListingBadges.topSpot) {
      bgColour = colour.brandAqua;
    }
    return ___EmotionJSX("span", {
      key: label,
      css: styles.badge(badgeEnum, bgColour)
    }, label);
  };
  var addBadge = type => ({
    badge: type.name,
    label: type.label
  });
  var getBadges = () => {
    if (props.annotations) {
      return props.annotations;
    }
    var badges = [];
    if (props.displayHome) {
      badges.push(addBadge(ListingBadges.displayHome));
    }
    if (props.development) {
      badges.push(addBadge(ListingBadges.development));
    }
    if (props.newLand) {
      badges.push(addBadge(ListingBadges.newLand));
    }
    if (props.new) {
      badges.push(addBadge(ListingBadges.new));
    }
    if (props.priceReduced) {
      badges.push(addBadge(ListingBadges.priceReduced));
    }
    if (props.underOffer) {
      badges.push(addBadge(ListingBadges.underOffer));
    }
    if (props.rented) {
      badges.push(addBadge(ListingBadges.rented));
    }
    if (props.underApplication) {
      badges.push(addBadge(ListingBadges.underApplication));
    }
    if (props.overFiftyFiveEnabled) {
      badges.push(addBadge(ListingBadges.overFiftyFiveEnabled));
    }
    if (props.overSixtyEnabled) {
      badges.push(addBadge(ListingBadges.overSixtyEnabled));
    }
    if (props.featuredProperty) {
      badges.push(addBadge(ListingBadges.featuredProperty));
    } else if (props.propertyOfTheWeek) {
      badges.push(addBadge(ListingBadges.propertyOfTheWeek));
    } else if (props.topSpot) {
      badges.push(addBadge(ListingBadges.topSpot));
    }
    if (props.fullyFurnished) {
      badges.push(addBadge(ListingBadges.fullyFurnished));
    }
    if (props.sold) {
      badges.push(addBadge(ListingBadges.sold));
    }
    if (props.dreamHome) {
      badges.push(addBadge(ListingBadges.dreamHome));
    }
    return badges;
  };
  var underOffer = props.annotations ? props.annotations.filter(badge => badge.badge === ListingBadges.underOffer.name) : [];
  return ___EmotionJSX("div", {
    className: props.className,
    css: styles.wrapper
  }, props.annotations && underOffer.length > 0 ? getBadge(ListingBadges.underOffer, ListingBadges.underOffer.label) : getBadges().map(badge => getBadge(ListingBadges[badge.badge], badge.label)));
};
export default AllhomesListingCardBadges;